import { styled } from '@withjoy/joykit/theme';
import { anatomy } from '@shared/joykit/packages/core/common/utils/anatomy';
import type { MultiPartStyleConfig, PartsStyleObject } from '@shared/joykit/packages/core/common/utils/styleConfig';
import { createMultiPartStylesContext } from '@shared/joykit/packages/core/common/utils/styleConfig';
import type { StyleSystemProps } from '../Box';
import { Box } from '../Box';
import { ARROW_WIDTH } from './Popover.constants';
import type { PopoverV2Props } from './Popover.types';

// Popper attaches a render after the content mounts, so the first paint sits at top/left 0.
// Keep the content transparent until Popper's first write adds `data-popper-placement`. Opacity
// rather than `visibility` so the content stays in the accessibility tree meanwhile; the root's
// own opacity belongs to the enter spring, hence the child.
export const PopoverRoot = styled(Box)`
  &:not([data-popper-placement]) > * {
    opacity: 0;
  }
`;
export const PopoverContent = styled(Box)``;
export const PopoverBody = styled(Box)``;
export const PopoverArrow = styled(Box)``;

const baseStyleRoot: StyleSystemProps = {
  left: 0,
  opacity: 0,
  position: 'absolute',
  top: 0,
  zIndex: 'popover',
  _focusVisible: { outline: 'none' },
};

const baseStyleContent: StyleSystemProps = {
  // `radii[3]` (8px) — keeps floating surfaces on the same corner as the fields that
  // trigger them (InputV2, SelectV1, TextArea) and the `Menu` list they usually wrap.
  borderRadius: 3,
  backgroundColor: 'white',
  boxShadow: '0px 4px 12px -2px rgba(44, 41, 37, 0.25), 0px 3px 7px -3px rgba(0, 0, 0, 0.3)',
  display: 'inline-block',
  // transformOrigin: sharedProps.$transformOrigin,
};

const baseStyleBody: StyleSystemProps = {
  position: 'relative',
};

const baseStyleArrow: StyleSystemProps = {
  backgroundColor: 'white',
  position: 'absolute',
  height: `${ARROW_WIDTH}px`,
  transform: 'rotate(45deg)',
  width: `${ARROW_WIDTH}px`,
};

export const Hidden = styled.div`
  display: none;
`;

const popoverAnatomy = anatomy('Popover').parts('root', 'content', 'body', 'arrow');

const popoverBaseStyle: PartsStyleObject<typeof popoverAnatomy> = {
  root: baseStyleRoot,
  content: baseStyleContent,
  body: baseStyleBody,
  arrow: baseStyleArrow,
};

const popoverStyles: MultiPartStyleConfig<PopoverV2Props, typeof popoverAnatomy> = {
  parts: popoverAnatomy.keys,
  baseStyle: popoverBaseStyle,
};

const [PopoverStylesProvider, usePopoverStyles] = createMultiPartStylesContext(popoverAnatomy);

export { PopoverStylesProvider, usePopoverStyles, popoverStyles };
